import React, { FC, memo } from 'react';
import classNames from 'classnames';

import { CustomListItem } from 'application/components/CustomList';
import { useModalContext } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import useInvoiceRequestPresenter from './useInvoiceRequestPresenter';
import useInvoiceRequestController from './useInvoiceRequestController';
import { InvoiceContent, InvoiceActions, InvoiceContentSize } from './components';
import { InvoiceRequestProps } from './types';
import { TEXTS } from './texts';

import styles from './index.module.scss';

const InvoiceRequest: FC<InvoiceRequestProps> = ({
  paymentMethodId,
  isSelected,
  switcherHidden,
  contentSize,
  setSelectedItemId,
}) => {
  const { openModal, closeAllModals } = useModalContext();

  const { isPaymentByInvoiceRequested, isPaymentRequestLoading, paymentByInvoiceRequest } =
    useInvoiceRequestPresenter();

  const { onPaymentByInvoiceRequest } = useInvoiceRequestController({
    invoiceRequestModalOkButton: (
      <Button
        key="button_invoice_requested_modal"
        elementId="button_invoice_requested_modal"
        type={ButtonType.PRIMARY}
        onClick={closeAllModals}>
        {TEXTS.INVOICE_REQUEST_INFO_MODAL_OK}
      </Button>
    ),
    openModal,
    paymentByInvoiceRequest,
  });

  return (
    <div className={styles.InvoiceRequest}>
      <CustomListItem
        id={paymentMethodId}
        elementId={`payment_method_${paymentMethodId}`}
        contentId="invoice_payment"
        isSelected={isSelected}
        switcherHidden={switcherHidden}
        small={contentSize === InvoiceContentSize.SMALL}
        onChange={() => setSelectedItemId(paymentMethodId)}
        content={
          <InvoiceContent
            size={contentSize}
            className={classNames(styles.InvoiceRequest, {
              [styles.InvoiceRequestSelected]: isSelected,
            })}
          />
        }
        footer={
          <InvoiceActions
            isPaymentByInvoiceRequested={isPaymentByInvoiceRequested}
            isLoading={isPaymentRequestLoading}
            onPaymentByInvoiceRequest={onPaymentByInvoiceRequest}
          />
        }
      />
    </div>
  );
};

export default memo(InvoiceRequest);
